import {
    CHANGE_VIEW,
    INC_SCRATCHER_POS,
    SELECT_CHOICE,
    RESTART_QUIZ,
    CHANGE_FAQ,
    VIEW_DETAIL,
    DEC_DETAIL_POS,
    INC_DETAIL_POS,
    FINISH_CALC_RESULTS,
    START_CALC_RESULTS,
    TOGGLE_AUDIO,
    SELECT_FINAL_CHOICE,
    SET_USER_ID,
    SET_SESSION_ID
} from '../actions/actions';
import slides from '../slides';
import scratchers, { getNextSlug, getPrevSlug } from '../scratchers';
import { getInitialQuestions, initialChoices } from '../initialState';
import { addResultToFirebase } from '../firebase';

// TODO: break into separate UI and Logic reducer and create a root reducer
// TODO: make reducer functions more composable

const rootReducer = (state = {}, action) => {
    let previousView = '';
    switch (action.type) {
        case SET_USER_ID:
            return Object.assign({}, state, {
                userId: action.id,
            });
        case SET_SESSION_ID:
            return Object.assign({}, state, {
                sessionId: action.id,
            });
            /***
             * Toggle Audio
             ****/
        case TOGGLE_AUDIO:
            window.ga('send', 'event', 'gameplay', 'click', 'mute', !state.isPlaying);
            return Object.assign({}, state, {
                isPlaying: !state.isPlaying,
            });
            /***
             * Change view
             ****/
        case CHANGE_VIEW:
            // redirect check
            // console.log('action.view: ' +action.view);
            // console.log('previousView: ' +previousView);
            // console.log('state.view: ' +state.view);
            // console.log('BREAK');
            if (state.scratcherPosition > state.numberOfQuestions && action.view === 'questions') {
                action.view = 'results'
                previousView = 'questions';
            } else {
                previousView = state.view
            }

            // console.log('action.view: ' +action.view);
            // console.log('previousView: ' +previousView);
            // console.log('state.view: ' +state.view);

            if (action.view === 'questions'){
                window.ga('set', 'page', `/question/${state.scratcherPosition}/`);
                window.ga('send', 'pageview');


                if (previousView === 'intro') {
                    // console.log('from intro page');
                    window.ga('send', 'event', 'gameplay', 'click', 'startquiz');
                }
                // console.log('scratcherPosition: ' + state.scratcherPosition);
                // console.log('numberOfQuestions: ' + state.numberOfQuestions);
                // console.log('fire: question/' +state.scratcherPosition+ '/ changeviewadfkjbdlfkgndjk');
                // console.log(state.scratcherPosition);

                // window.ga('set', 'page', '/question/'  +state.scratcherPosition+  '/');
                // window.ga('send', 'pageview');


            } else {
                let gaView;
                if (action.view === 'info') {
                    gaView = '/tickets/';
                } else if (action.view === 'intro') {
                    gaView = '/';
                } else if (action.view === 'results') {
                    gaView = '/result/';
                } else {
                    gaView = '/' +action.view+ '/';
                }
                // console.log(gaView);
                // console.log('gaView: ' +gaView);
                window.ga('set', 'page', gaView);
                window.ga('send', 'pageview');
            }

            return Object.assign({}, state, {
                view: action.view,
                previousView
            });
            /***
             * Select Quiz Choice and Increment Scratcher Count
             ****/
        case SELECT_CHOICE:
            // redirect check if # of questions answered is larger than # of questions
            const view = nextViewOnChoiceIfQuizFinished(state, previousView);
            // add 1 to counter of scratcher
            let choices = state.scratcherChoice;
            const pos = choices.findIndex(choice => choice.slug === action.choice);
            choices[pos].count++;

            //sort selected scratcher by count and weight
            choices.sort((a, b) => a.count > b.count || (a.count === b.count && a.weight > b.weight) ? -1 : 1);

            // if final choice dispatch google-analytics event
            if (state.scratcherPosition === state.numberOfQuestions) {
                window.ga('send', 'event', 'gameplay', 'result', choices[0].slug);

                addResultToFirebase(choices[0].slug, state.userId, state.sessionId);
            }

            return Object.assign({}, state, {
                scratcherChoice: choices,
                scratcherPosition: state.scratcherPosition + 1,
                view,
                previousView,
                personality: [...state.personality, action.personality],
            });
            /***
             * Increment Quiz Position
             ****/
        case INC_SCRATCHER_POS:
            return Object.assign({}, state, {
                scratcherPosition: state.scratcherPosition + 1,
            });
            /***
             * Restart Quiz:
             ****/
        case RESTART_QUIZ:
            // console.log('fire: question/1/ restart');
            window.ga('set', 'page', '/question/1/');
            window.ga('send', 'pageview');
            window.ga('send', 'event', 'gameplay', 'click', 'restart');
            // TODO: pull in fresh array of init choices instead of map
            const resetChoice = state.scratcherChoice.map(choice => { choice.count = 0; return choice });

            return Object.assign({}, state, {
                scratcherPosition: 1,
                view: 'questions',
                questions: getInitialQuestions(slides),
                scratcherChoice: resetChoice,
                personality: [],
            });
        case CHANGE_FAQ:
            return Object.assign({}, state, {
                faqDropdown: state.faqDropdown === action.slug ? 'none' : action.slug,
            });
        case VIEW_DETAIL:
            window.ga('set', 'page', `/tickets/${action.slug}/`);
            window.ga('send', 'pageview');
            return Object.assign({}, state, {
                view: 'detail',
                scratcherDetail: action.slug,
                previousView: state.view
            });
        case INC_DETAIL_POS:
            return Object.assign({}, state, {
                scratcherDetail: getNextSlug(scratchers, action.slug)
            });
        case DEC_DETAIL_POS:
            return Object.assign({}, state, {
                scratcherDetail: getPrevSlug(scratchers, action.slug)
            });
        case START_CALC_RESULTS:
        case FINISH_CALC_RESULTS:
        default:
            return state;
    }
};

function nextViewOnChoiceIfQuizFinished(state, previousView) {
    let view = '';
    if (state.scratcherPosition === state.numberOfQuestions && state.view === 'questions') {
        view = 'results';
        previousView = 'questions';
        // console.log('fire: result/');
        window.ga('set', 'page', '/result/');
        window.ga('send', 'pageview');
    } else {
        view = state.view;
        previousView = 'questions';
    }

    return view;
}

// Export Reducer
export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/reducers.js
 **/